 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/ebb'
 import TLU from '@/components/tlu'
 import MM from '@/components/mm'
 import LOVE_1 from '@/components/love_1'
 import TITLEPAGE from '@/components/Titlepage'
 import EPIGRAPH from '@/components/epigraph'
 import A7815040960651 from '@/components/9781504096065-1'
 import A7815040960652 from '@/components/9781504096065-2'
 import A7815040960653 from '@/components/9781504096065-3'
 import A7815040960654 from '@/components/9781504096065-4'
 import A7815040960655 from '@/components/9781504096065-5'
 import A7815040960656 from '@/components/9781504096065-6'
 import A7815040960657 from '@/components/9781504096065-7'
 import A7815040960658 from '@/components/9781504096065-8'
 import A7815040960659 from '@/components/9781504096065-9'
 import A78150409606510 from '@/components/9781504096065-10'
 import A78150409606511 from '@/components/9781504096065-11'
 import A78150409606512 from '@/components/9781504096065-12'
 import A78150409606513 from '@/components/9781504096065-13'
 import A78150409606514 from '@/components/9781504096065-14'
 import A78150409606515 from '@/components/9781504096065-15'
 import A78150409606516 from '@/components/9781504096065-16'
 import A78150409606517 from '@/components/9781504096065-17'
 import A78150409606518 from '@/components/9781504096065-18'
 import A78150409606519 from '@/components/9781504096065-19'
 import A78150409606520 from '@/components/9781504096065-20'
 import A78150409606521 from '@/components/9781504096065-21'
 import A78150409606522 from '@/components/9781504096065-22'
 import A78150409606523 from '@/components/9781504096065-23'
 import A78150409606524 from '@/components/9781504096065-24'
 import A78150409606525 from '@/components/9781504096065-25'
 import A78150409606526 from '@/components/9781504096065-26'
 import LOVE_2 from '@/components/love_2'
 import PREVIEWPREVIEW from '@/components/Preview/preview'
 import PREVIEWCOVER from '@/components/Preview/cover'
 import PREVIEW03_PROLOGUE from '@/components/Preview/03_Prologue'
 import PREVIEW05_PT1_CHAPTER01 from '@/components/Preview/05_Pt1_chapter01'
 import PREVIEW06_PT1_CHAPTER02 from '@/components/Preview/06_Pt1_chapter02'
 import A78150409606527 from '@/components/9781504096065-27'
 import A78150409606528 from '@/components/9781504096065-28'
 import COPYRIGHT from '@/components/copyright'
 import SERIESBACKAD from '@/components/seriesbackad'
 import ORIMAD from '@/components/ORIM-ad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/tlu",
 			"name" : "tlu",
 			"component" : TLU
 		},
 		{
 			"path" : "/mm",
 			"name" : "mm",
 			"component" : MM
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Titlepage",
 			"name" : "Titlepage",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/epigraph",
 			"name" : "epigraph",
 			"component" : EPIGRAPH
 		},
 		{
 			"path" : "/9781504096065-1",
 			"name" : "9781504096065-1",
 			"component" : A7815040960651
 		},
 		{
 			"path" : "/9781504096065-2",
 			"name" : "9781504096065-2",
 			"component" : A7815040960652
 		},
 		{
 			"path" : "/9781504096065-3",
 			"name" : "9781504096065-3",
 			"component" : A7815040960653
 		},
 		{
 			"path" : "/9781504096065-4",
 			"name" : "9781504096065-4",
 			"component" : A7815040960654
 		},
 		{
 			"path" : "/9781504096065-5",
 			"name" : "9781504096065-5",
 			"component" : A7815040960655
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js